/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TasksBoardsList/view.blocks to change it.
import Boards from './Boards/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TasksBoardsList({
  children,
  viewPath = "/DesignSystem/TasksBoardsList"
  
}) {
  return (<React.Fragment
>
<Boards
  viewPath={`${viewPath}/Boards`}
/>
{children}
</React.Fragment>)
}